;(() => {
  const modalForm = document.querySelector('.modal-image-form')
  //if on a page with a modalForm
  if (modalForm) {
    //open modal
    document.querySelectorAll('a[href$="#trade-enquiry"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        modalForm.classList.add('active')
      })
    })

    //close modal
    document
      .querySelectorAll('.modal-image-form button.close, .modal-background')
      .forEach((element) => {
        element.addEventListener('click', () =>
          modalForm.classList.remove('active')
        )
      })
  }
})()
